import { useCallback, useMemo } from "react";
import api from "../../services/api";

const useCompanySettings = () => {
  const getAll = useCallback(async (companyId) => {
    const { data } = await api.request({
      url: `/companySettings/${companyId}`,
      method: "GET",
    });

    return data;
  }, []);

  const get = useCallback(async (params) => {
    const { data } = await api.request({
      url: "/companySettingOne",
      method: "GET",
      params,
    });
    return data;
  }, []);

  const update = useCallback(async (payload) => {
    const { data } = await api.request({
      url: "/companySettings",
      method: "PUT",
      data: payload,
    });
    return data;
  }, []);

  return useMemo(
    () => ({
      getAll,
      get,
      update,
    }),
    [getAll, get, update]
  );
};

export default useCompanySettings;
